export enum RenderCellTypes {
  BUTTON = "BUTTON",
  BUTTON_WITH_ICON = "BUTTON_WITH_ICON",
  TEXT = "TEXT",
  TEXT_WITH_COPY = "TEXT_WITH_COPY",
  NUMBER = "NUMBER",
  STATUS = "STATUS",
  INFO_TOOLTIP = "INFO_TOOLTIP",
  POPOVER_INFO = "POPOVER_INFO",
  DATE = "DATE",
  TIME = "TIME",
  DATETIME = "DATETIME",
  NUMBER_PERCENT = "NUMBER_PERCENT",
  COUNT_WITH_ICON = "COUNT_WITH_ICON",
  BUTTON_WITH_ACTION_ICONS = "BUTTON_WITH_ACTION_ICONS",
  ACTION_BUTTONS = "ACTION_BUTTONS",
  RATE = "RATE",
  IMAGE = "IMAGE",
  CHIP_ARRAY = "CHIP_ARRAY",
}
